import { render, staticRenderFns } from "./BookingNotes.vue?vue&type=template&id=619efab2"
import script from "./BookingNotes.vue?vue&type=script&lang=js"
export * from "./BookingNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports